import React from 'react'
import Collection from '../common/collection'

function CollectionO({ props }) {
  return (
    <Collection
      alt="Cápsulas"
      src={[
        'https://volverse-negro-daniel.s3.amazonaws.com/images/14.+c%C3%A1psula27.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/14.+c%C3%A1psula67.jpg',
      ]}
    />
  )
}


export default CollectionO
